import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FeedbackInfoComponent, SnackbarService, FeedbackFailComponent } from 'ok-angular-shared/components';
import { HttpErrorResponse } from '@angular/common/http';
import { DynamicPriceChartDialogService } from './dynamic-price-chart-dialog.service';
import { DynamicPriceChartComponent } from './components/dynamic-price-chart/dynamic-price-chart.component';
import { PriceChartDataResponse } from './dynamic-price-chart.interface';
import { ApiErrorResponse } from 'src/app/features/prices/price-policies/helpers/price-policy-error.helper';
import { LocationDetailsConnector } from '../../../charging-station-location-details/charging-station-locations-details.model';

export interface DynamicPriceChartDialogData {
  locationAddress: string;
  stationIdentifier: string;
  connector: LocationDetailsConnector;
}

@Component({
  selector: 'adm-dynamic-price-chart-dialog',
  templateUrl: './dynamic-price-chart-dialog.component.html',
  styleUrls: ['./dynamic-price-chart-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    MatIcon,
    FeedbackInfoComponent,
    DynamicPriceChartComponent,
    FeedbackFailComponent,
  ],
})
export class DynamicPriceChartDialogComponent implements OnInit {
  private data = inject<DynamicPriceChartDialogData>(MAT_DIALOG_DATA);
  private dynamicPriceChartDialogService = inject(DynamicPriceChartDialogService);
  private snackbarService = inject(SnackbarService);

  connector = this.data.connector;
  locationAddress = this.data.locationAddress;
  stationIdentifier = this.data.stationIdentifier;
  priceChartData = signal<PriceChartDataResponse | undefined>(undefined);
  hasForecast = signal(false);

  private static readonly errorMessages: Record<number, string> = {
    300001: 'Stik ikke fundet',
    10610: 'Stik har fast pristype',
  };

  ngOnInit() {
    this.dynamicPriceChartDialogService.getPriceChartData(this.connector.identifier).subscribe({
      next: data => {
        if (!data.forecast?.length) {
          return;
        }
        this.priceChartData.set(data);
        this.hasForecast.set(true);
      },
      error: (error: HttpErrorResponse) => {
        const apiError = error.error as ApiErrorResponse['error'];
        const message = DynamicPriceChartDialogComponent.errorMessages[apiError?.code] ?? 'Der skete en ukendt fejl';
        this.snackbarService.error(message);
      },
    });
  }
}
